import React from 'react';
import { Mail, Phone, MessageCircle } from 'lucide-react';
import { images, mockData } from '../utils/mock';

export const Footer = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(mockData.contact.whatsappMessage);
    window.open(`https://wa.me/${mockData.contact.whatsappNumber}?text=${message}`, '_blank');
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-zinc-950 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Logo and Description */}
          <div>
            <img
              src={images.logo}
              alt="Agente 360"
              className="h-12 w-auto mb-4"
            />
            <p className="text-white/60 text-sm leading-relaxed">
              Programa diseñado para familias de futbolistas que buscan estructura, claridad y dirección en las decisiones más importantes.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Enlaces</h4>
            <div className="space-y-3">
              <button
                onClick={() => scrollToSection('programa')}
                className="block text-white/60 hover:text-orange-500 transition-colors duration-300 text-sm"
              >
                El Programa
              </button>
              <button
                onClick={() => scrollToSection('modulos')}
                className="block text-white/60 hover:text-orange-500 transition-colors duration-300 text-sm"
              >
                Módulos
              </button>
              <button
                onClick={() => scrollToSection('quien')}
                className="block text-white/60 hover:text-orange-500 transition-colors duration-300 text-sm"
              >
                Quién Soy
              </button>
              <button
                onClick={() => scrollToSection('inversion')}
                className="block text-white/60 hover:text-orange-500 transition-colors duration-300 text-sm"
              >
                Inversión
              </button>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contacto</h4>
            <div className="space-y-3">
              <button
                onClick={handleWhatsAppClick}
                className="flex items-center gap-3 text-white/60 hover:text-orange-500 transition-colors duration-300 text-sm group"
              >
                <MessageCircle className="w-5 h-5 group-hover:scale-110 transition-transform duration-300" />
                <span>WhatsApp</span>
              </button>
              <a
                href="mailto:info@agente360.com"
                className="flex items-center gap-3 text-white/60 hover:text-orange-500 transition-colors duration-300 text-sm group"
              >
                <Mail className="w-5 h-5 group-hover:scale-110 transition-transform duration-300" />
                <span>info@agente360.com</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm">
              © {new Date().getFullYear()} Agente 360. Todos los derechos reservados.
            </p>
            <p className="text-white/40 text-sm">
              Creado por Edgar Merino - Agente FIFA
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
